import {Controller} from "@hotwired/stimulus"

export class AlarmOrderAdditionalResourcesController extends Controller {
	static targets = ["template", "container", "select", "picker"]

	connect() {
		this.addCounter = 0
		if (!this.hasSelectTarget) return
		this.containerTarget.querySelectorAll("tr[data-resource-id]").forEach(row => this.#hideOption(row.dataset.resourceId))
		this.#refreshPicker()
	}

	add() {
		const resourceId = this.selectTarget.value
		const template = this.templateTargets.find(t => t.dataset.resourceId === resourceId)
		if (!template) return
		const html = template.innerHTML.replace(/NEW_RECORD/g, `${Date.now()}${this.addCounter++}`)
		this.containerTarget.insertAdjacentHTML("beforeend", html)
		this.#hideOption(resourceId)
		this.#refreshPicker()
	}

	remove(event) {
		const row = event.target.closest("tr")
		this.#showOption(row.dataset.resourceId)
		row.remove()
		this.#refreshPicker()
	}

	#hideOption(resourceId) {
		const option = this.#option(resourceId)
		if (!option) return
		option.hidden = true
		option.disabled = true
		if (this.selectTarget.value === resourceId) {
			const visible = Array.from(this.selectTarget.options).find(o => !o.hidden)
			this.selectTarget.value = visible ? visible.value : ""
		}
	}

	#showOption(resourceId) {
		const option = this.#option(resourceId)
		if (!option) return
		option.hidden = false
		option.disabled = false
		if (!this.selectTarget.value) this.selectTarget.value = resourceId
	}

	#option(resourceId) {
		return this.selectTarget.querySelector(`option[value="${resourceId}"]`)
	}

	#refreshPicker() {
		const anyVisible = Array.from(this.selectTarget.options).some(o => !o.hidden)
		this.pickerTarget.classList.toggle("d-none", !anyVisible)
	}
}
